import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { BriefingSortByEnum } from '../../enums/briefing-sort-by.enum';
import { getBriefingSortByOptions } from '../../models/briefing-sort-by-options.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { BriefingSortByFieldModel } from '../../models/briefing-sort-by.field.model';
import { SearchCriteriaSortFieldEnum } from '../../../../api/mentions/enum/search-criteria-sort-field.enum';
import { SortOrderEnum } from '../../../../api/shared/enums/sort-order.enum';
import { MentionSearchCriteriaModel } from '../../../Shared/models/mention-search-criteria.model';
import { BriefingConfigService } from '@Common/MonitorShared/services/briefing-config.service';

@Component({
    selector: 'agpr-curated-sort-by-field',
    templateUrl: './curated-sort-by-field.component.html',
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => CuratedSortByFieldComponent)
        },
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CuratedSortByFieldComponent
        }
    ],
    standalone: false
})
export class CuratedSortByFieldComponent extends AbstractFormFieldComponent implements ControlValueAccessor, OnInit {

    @Input() declare field: BriefingSortByFieldModel;
    @Input() declare value: MentionSearchCriteriaModel;

    options: DropdownOptionModel<BriefingSortByEnum>[] = [];
    selectedOption: DropdownOptionModel<BriefingSortByEnum> = null;

    private subscriptions: Subscription[] = [];

    constructor(
        private briefingConfigService: BriefingConfigService,
    ) {
        super();
    }

    ngOnInit() {
        this.options = [
            {
                label: 'Briefings.input.sortMentionsBy.custom',
                value: BriefingSortByEnum.MANUAL
            },
            ...getBriefingSortByOptions()
        ];

        this.subscriptions.push(
            this.briefingConfigService.getConfig().pipe(filter(x => !!x)).subscribe(config => {
                if (config.hasEngagementUpdates) {
                    this.options.push({
                        label: 'Briefings.input.sortMentionsBy.engagementMost',
                        value: BriefingSortByEnum.ENGAGEMENT_MOST
                    });
                }
                this.setSelectedOption();
            })
        );
    }

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(value: any) {
        this.value = value;
        this.setSelectedOption();
    }

    registerOnChange(fn): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }

    onDropdownChanged(value: any): void {
        this.value = value;
        this.onModelChange(this.value);
        this.changes.emit(this.value);
    }

    private setSelectedOption() {
        if (this.options && this.options.length > 0) {

            this.options.forEach(option => {
                if (option.value === this.value) {
                    this.selectedOption = option;
                }
            });

            if (!this.selectedOption) {
                // by default, select the first option
                this.selectedOption = this.options[0];
                this.onDropdownChanged(this.selectedOption.value);
            }
        }
    }
}

